import AudioManager from 'scripts/util/AudioManager';
import AssetLoader from "../loaders/AssetLoader";
import * as BABYLON from 'babylonjs'
import Main from "scripts/3d/experience/Main";

class Star {
  constructor (mesh) {
    const index =  Math.round(Math.random() * 1000)
    this.view = new BABYLON.TransformNode('Star' + index)
    this.view.rotationQuaternion = null
    
    this.mesh = mesh
    this.mesh.parent = this.view
    this.mesh.rotationQuaternion = null
    this.mesh.position.y = 0.25
    this.isHit = false

    this.collider = BABYLON.MeshBuilder.CreateBox("StarCollider" + index, {width: 1.5, size: 1.2});
    this.collider.position.y = .5
    this.collider.parent = this.view
    this.collider.isVisible = false

    this.colorToggle = false
    this.colorIndex = 0
    this.colorInterval = null
    this.colors = [
      new BABYLON.Color3.FromHexString('#ff8b8b'),
      new BABYLON.Color3.FromHexString('#ffd668'),
      new BABYLON.Color3.FromHexString('#5cff72'),
      new BABYLON.Color3.FromHexString('#84e3ff'),
      new BABYLON.Color3.FromHexString('#d9abff'),
    ]

    setInterval(() => {
      this.colorIndex = (this.colorIndex + 1) % this.colors.length
      this.mesh.material.albedoColor = this.colors[this.colorIndex]
    }, 100)

    this.particleSystem = new BABYLON.GPUParticleSystem(
      "starParticles" + index,
      20
    );
    this.particleSystem.particleTexture = AssetLoader.getTexture("PresentSparks").clone();
    this.particleSystem.startSpriteCellID = 0;
    this.particleSystem.spriteCellHeight = 128;
    this.particleSystem.spriteCellWidth = 128;
    this.particleSystem.spriteRandomStartCell = true;
    this.particleSystem.isAnimationSheetEnabled = true;
    this.particleSystem.minLifeTime = 0.2;
    this.particleSystem.maxLifeTime = 1;
    this.particleSystem.emitRate = 3;
    this.particleSystem.isLocal = true;
    this.particleSystem.minSize = 0.2;
    this.particleSystem.maxSize = 0.4;
    this.particleSystem.minLifeTime = 1;
    this.particleSystem.maxLifeTime = 1.5;
    this.particleSystem.color1 = new BABYLON.Color4(1, 1, 1, 0);
    this.particleSystem.color2 = new BABYLON.Color4(1, 1, 1, 1);
    this.particleSystem.colorDead = new BABYLON.Color4(1, 1, 1, 0);
    this.particleSystem.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD;
    this.particleSystem.particleEmitterType.directionRandomizer = 1;
    this.particleSystem.direction1 = new BABYLON.Vector3(0.2, 0.5, 0);
    this.particleSystem.direction2 = new BABYLON.Vector3(-0.2, 0.5, 0);
    this.particleSystem.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;

    this.meshEmitter = BABYLON.MeshBuilder.CreateBox("starEmitter", {
      height: 0.05,
      width: 0.05,
      depth: 0.05,
    });
    this.meshEmitter.position.y = 0.6;
    if (this.isAir) this.meshEmitter.position.y += 1.8;
    this.collider.addChild(this.meshEmitter);
    this.meshEmitter.isVisible = false;
    this.meshEmitter.isBlocker = false;
    this.particleSystem.emitter = this.meshEmitter;
    this.particleSystem.start();
    this.particleSystem.parent = this.collider;
  } 

  setConfig(config) {
    this.config = config
    
    const {position, rotation, scaling} = this.config
    
    this.view.rotation = rotation.clone()
    this.view.position = position.clone()
    this.view.scaling = scaling.clone()
    this.mesh.scaling = new BABYLON.Vector3(config.scaling.x*8,config.scaling.y*8,config.scaling.z*8)
  }

  hit () {
    this.isHit = true
    this.mesh.isVisible = false
    this.particleSystem.stop();
    this.particleSystem.reset();
    AudioManager.playSound('starCollect');
    Main.VFX.stars(0)
  }

  reset () {
    this.mesh.isVisible = true
    this.isHit = false
  }

  update () {
    if(this.isHit === false) {
      this.mesh.rotation.y += .05
    }
  }

  destroy() {
    this.collider.parent = null
    this.collider.isVisible = false
    this.collider.dispose()

    this.mesh.parent = null
    this.mesh.isVisible = false
    this.mesh.dispose()

    this.view.parent = null
    this.view.isVisible = false
    this.view.dispose()

    this.particleSystem.stop();

    clearInterval(this.colorInterval)
  }
}

export default Star